PopOver = require 'app/scripts/views/lib/pop-over'
CardMoveView = require 'app/scripts/views/card/card-move-view'
Util = require 'app/scripts/lib/util'
{ track } = require '@trello/analytics'
CardCopyView = require 'app/scripts/views/card/card-copy-view'
Auth = require 'app/scripts/db/auth'
_ = require 'underscore'

module.exports.openMoveMenu = (elem) ->
  PopOver.toggle
    elem: elem
    view: CardMoveView
    options: { @model, @modelCache }

  return

module.exports.openMoveFromHeader = (e) ->
  Util.stop(e)
  @openMoveMenu(@$('.js-open-move-from-header'), 20)
  track("Card Detail", "Move Button (via Header)", undefined, @model.trackProperty())
  return

module.exports.moveCard = (e) ->
  Util.stop(e)
  @openMoveMenu(@$('.js-move-card'), 35)
  track("Card Detail", "Sidebar", "Open Move Menu", @model.trackProperty())
  return

module.exports.copyCard = (e) ->
  Util.stop(e)

  PopOver.toggle
    elem: @$('.js-copy-card')
    view: CardCopyView
    options: { @model, @modelCache }

  track("Card Detail", "Sidebar", "Open Copy Menu", @model.trackProperty())
  return

module.exports.renderCopyCard = ->
  hasBoards = _.any Auth.me().boardList.models, (board) -> !board.get('closed')
  @$('.js-copy-card').toggleClass('hide', !hasBoards)
